<template>
  <div>
    <div class="information">
      <div class="lef">
        <!-- 电商资讯tab -->
        <div class="lianmei">
          <div class="lianmen_lef">
            <div>
              <a href="#" @click="goToCommerce(429)">大杂烩</a>
              <span>-趣事乐事好事</span>
            </div>
          </div>
          <div class="daohang">
            <div class="list">
              <a href="#" @click="goToDetail(item.id,item.pid)" v-for="item in listData" :key="item.article_id">{{item.article_name}}</a>
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="recommend">
          <!-- 电商资讯 -->
          <div class="reco">
            <div class="title">大杂烩精选推荐</div>
            <div class="conte"
              v-for="item in leftData"
              :key='item.id'
               @click="goToDetail(item.id,item.pid)"
            >
              <div class="conte_img">
                <img
                  :src="item.imgurl"
                  alt
                />
              </div>
              <div class="conte-tir">
                <span>{{item.title}}</span>
              </div>
            </div>
            
          </div>
          <!-- 人才缺口 -->
          <div class="gap_box">
            <div class="gap">
              <div class="gap_title"
                v-for="item in oneTitle"
                 @click="goToDetail(item.id,item.pid)"
                :key='item.id'
              >
                {{item.title}}
              </div>
              <div class="gap_container"
               @click="goToDetail(item.id,item.pid)"
                v-for="item in gap_containerData"
                :key='item.id'
              >
                <div class="gap_left">
                  <span class="gap_left_lf">{{item.source}}</span>
                  <span class="gap_left_rg">{{item.title}}</span>
                </div>
                <div class="gap_right">
                  <span>{{item.addtime}}</span>
                </div>
              </div>
              
            </div>
            <div class="gap">
              <div class="gap_title"
               @click="goToDetail(item.id,item.pid)"
                v-for="item in twoTitle"
                :key='item.id'
              >{{item.title}}</div>
              <div class="gap_container"
               @click="goToDetail(item.id,item.pid)"
                v-for="item in gap_maoData"
                :key='item.id'
              >
                <div class="gap_left">
                  <span class="gap_left_lf">{{item.source}}</span>
                  <span class="gap_left_rg">{{item.title}}</span>
                </div>
                <div class="gap_right">
                  <span>{{item.addtime}}</span>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div class="bott">
          <img src="http://aite.cnaite.cn/data/upload/shop/adv/06322553342524083.jpg" alt="">
        </div>
      </div>
      <div class="rig">
        <div class="blockchain">
          <div class="block_title">
            <span>电子商务专栏</span>
          </div>
          <div class="block_list">
            <p 
              v-for="item in blockchainData"
              :key='item.id'
               @click="goToDetail(item.id,item.pid)"
            >{{item.title}}</p>
          </div>
        </div>
        <div class="img_1">
          <img src="http://aite.cnaite.cn/data/upload/shop/adv/06384517180679641.jpg" alt="">
        </div>
        <div class="img_2">
          <img src="http://aite.cnaite.cn/data/upload/shop/adv/06322553615343517.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
export default {
  data() {
    return {
      listData: [],
      leftData: [],
      oneTitle: [],
      gap_containerData: [],
      twoTitle: [],
      gap_maoData: [],
      blockchainData: []
    }
  },
  created() {
    // 列表
    let url = encodeURI("/ajax/App_ArchiveClass.ashx?nums=7&class_id=429&action=article_count");
    axios.get(url).then(res => {
       res.data.forEach(element => {
        element.pid = 429;
      });
      this.listData = res.data;
    });
    // 精选推荐
    let comm_params = {
      classid: 429,
      count: 4,
      action: 'tuijian'
    }
    axios.post('/ajax/ArchiveJson.ashx', Qs.stringify(comm_params)).then(res => {
      res.data.forEach(element => {
        element.pid = 429;
      });
      this.leftData = res.data;
    });
    // 曾国
     let renk_params = {
      classid: 429,
      count: 10,
      action: 'middlecommend'
    }
    axios.post('/ajax/ArchiveJson.ashx', Qs.stringify(renk_params)).then(res => {
      res.data.forEach(element => {
        element.pid = 429;
      });
      this.oneTitle = res.data.splice(0,1);
      this.gap_containerData = res.data.splice(0,4);
      this.twoTitle = res.data.splice(0,1);
      this.gap_maoData = res.data.splice(0,4);
    });
    // 区块链
    let blockchain_params = {
      class_id: 429,
      count: 50,
    }
    axios.post('/ajax/ArchiveJson.ashx', Qs.stringify(blockchain_params)).then(res => {
      res.data.forEach(element => {
        element.pid = 429;
      });
      let lockchainData = res.data.splice(0,28)
      this.blockchainData = res.data.splice(0,8)
    });
  },
  methods:{
    goToDetail(value,pid){
      this.$router.push({path:'/sxy/detail',query:{id:value,classId:pid}})
    },
    goToCommerce(id){
      this.$router.push({path:`/sxy/commerce/${id}`});
    }
  }
}
</script>
<style scoped lang="scss">
.information {
  display: flex;
  justify-content: space-between;
  .lef {
    width: 815px;
    padding: 0 20px 20px 20px;
    .lianmei {
      margin-bottom: 20px;
      border-bottom: 1px solid #ccc;
      width: 815px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 59px;
      line-height: 59px;
      .lianmen_lef {
        height: 59px;
        line-height: 59px;
        border-bottom: 2px solid #f30;
        width: 190px;
        div {
          a {
            height: 50px;
            line-height: 50px;
            margin-top: 9px;
            display: inline-block;
            font-weight: bold;
            font-size: 20px;
            color: #000;
            text-decoration: none;
          }
          span {
            color: #666464;
            font-size: 15px;
          }
        }
      }
      .daohang {
        width: 549px;
        height: 44px;
        .list {
          list-style: none;
          height: 44px;
          line-height: 44px;
          display: flex;
          justify-content: space-around;
          a {
            text-decoration: none;
            font-size: 16px;
            color: #666464;
          }
        }
      }
    }
    .recommend {
      display: flex;
      .reco {
        border-right: 1px solid #dcdcdc;
        margin-right: 10px;
        .title {
          font-size: 16px;
          color: #000;
          font-weight: bold;
          margin-bottom: 11px;
        }
        .conte {
          margin-bottom: 10px;
          display: flex;
          cursor: pointer;
          .conte_img {
            img {
              width: 87px;
              height: 58px;
              margin-right: 10px;
            }
          }
          .conte-tir {
            width: 215px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            span {
              font-size: 15px;
              color: #444;
            }
          }
        }
      }
      .gap {
        width: 480px;
        border-bottom: 1px solid #dcdcdc;
        padding-bottom: 10px;
        margin-bottom: 10px;
        .gap_title {
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 10px;
          cursor: pointer;
        }
        .gap_container {
          display: flex;
          justify-content: space-between;
          height: 33px;
          line-height: 33px;
          cursor: pointer;
          .gap_left {
            font-size: 15px;
            color: #444;
            display: flex;
            .gap_left_lf {
              width: 40px;
              overflow:hidden; 
              text-overflow:ellipsis; 
              white-space:nowrap;
            }
            .gap_left_rg {
              width: 220px;
              overflow:hidden; 
              text-overflow:ellipsis; 
              white-space:nowrap;
            }
          }
          .gap_right {
            font-size: 12px;
            color: #888;
          }
        }
      }
    }
    .bott {
      width: 855px;
      img {
        width: 100%;
        margin-left: -21px;
      }
    }
  }
  .rig {
    width: 300px;
    height: 420px;
    background: #Ffffff;
    padding: 0 15px 15px 15px;
    .blockchain {
      .block_title {
        height: 58px;
        line-height: 58px;
        border-bottom: 1px solid #CCC;
        span {
          margin-top: 9px;
          margin-bottom: 12px;
          text-indent: 0;
          font-size: 18px;
          font-weight: bold;
          color: #333333;
        }
      }
      .block_list {
        margin-top: 20px;
        p {
          font-size: 14px;
          color: #555;
          margin: 0;
          height: 20px;
          line-height: 20px;
          cursor: pointer;
          overflow: hidden;
        }
      }
    }
    .img_1 {
      margin-top: 10px;
      img {
        width: 300px;
        height: 150px;
      }
    }
    .img_2 {
      margin-top: 20px;
      img {
        width: 300px;
        height: 120px;
      }
    }
  }
}
</style>